import { render } from "./Qna.vue?vue&type=template&id=c28348ae&scoped=true"
import script from "./Qna.vue?vue&type=script&lang=js"
export * from "./Qna.vue?vue&type=script&lang=js"

import "./Qna.vue?vue&type=style&index=0&id=c28348ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c28348ae"]])

export default __exports__